export const getValue = <T>(key: string): T | null => {
  const JSONValue = sessionStorage.getItem(key);
  return JSONValue ? (JSON.parse(JSONValue) as T) : null;
};

export const setItem = <T>(key: string, value: T): void => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

export const removeItem = (key: string): void => {
  sessionStorage.removeItem(key);
};

export const getLocalValue = <T>(key: string): T | null => {
  const JSONValue = JSON.parse(localStorage.getItem(key) as string);
  return JSONValue ? (JSON.parse(JSONValue) as T) : null;
};

export const getLocalValueS = (key: string) => {
  const JSONValue = JSON.parse(localStorage.getItem(key) as string);
  return JSONValue ? JSON.parse(JSONValue) : null;
};

export const setLocalItem = <T>(key: string, value: T): void => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const removeLocalItem = (key: string): void => {
  localStorage.removeItem(key);
};

export const getCookieValue = (key: string): any | null => {
  const name = key + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const allCookies = decodedCookie.split(';');
  for (let i = 0; i < allCookies.length; i++) {
    let currentCookie = allCookies[i];
    while (currentCookie.charAt(0) == ' ') {
      currentCookie = currentCookie.substring(1);
    }
    if (currentCookie.indexOf(name) == 0) {
      return currentCookie.substring(name.length, currentCookie.length);
    }
  }
  return null;
};

const COOKIE_EXPIRE_DAYS = 180;

export const setCookieValue = (key: string, value: any) => {
  const date = new Date();
  date.setTime(date.getTime() + COOKIE_EXPIRE_DAYS * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = key + '=' + value + ';' + expires + ';path=/';
};

export const removeCookieValue = (key: string) => {
  document.cookie = key + '=; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};
